import { memo, ReactNode } from 'react';

import * as ST from './styled';

type TEquipmentPopupProps = {
    isOpen: boolean,
    onClose: () => void,
    children: ReactNode,
};

const popupIndent = 24; // Отступ попапа от края экрана

const EquipmentPopup = ({ isOpen, onClose, children }: TEquipmentPopupProps) => {
    return (
        <ST.Popup
            isOpen={isOpen}
            onClose={onClose}
            popupIndent={popupIndent}
            customStyles={ST.PopupCustomStyles}
        >
            {children}
        </ST.Popup>
    );
};

export default memo(EquipmentPopup);
